import React from "react";

const TestimonialAreaItem = (props) => {
  return (
    <div className="testimonial-item">
      <div className="testimonial-content">
          <p className="mb-10">{props.item.desc}</p>
          <div className="rating" style={{textAlign: "right"}}>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
              <i className="fas fa-star"></i>
          </div>
      </div>
      <div className="testimonial-info mt-20">
        <div className="thumb">
          <img
            src={`/img/images/testimonial_avatar0${props.item.src}.jpeg`}
            alt=""
          />
        </div>
        <div className="content">
          <h4 className="title">{props.item.title}</h4>
          <p>{props.item.designation}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialAreaItem;
